import { render, staticRenderFns } from "./TextAreaComponent.vue?vue&type=template&id=25afb78a&"
import script from "./TextAreaComponent.vue?vue&type=script&lang=ts&"
export * from "./TextAreaComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25afb78a')) {
      api.createRecord('25afb78a', component.options)
    } else {
      api.reload('25afb78a', component.options)
    }
    module.hot.accept("./TextAreaComponent.vue?vue&type=template&id=25afb78a&", function () {
      api.rerender('25afb78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Elements/TextAreaComponent.vue"
export default component.exports